// extracted by mini-css-extract-plugin
module.exports = {"medium-legacy":"768px","wrapper":"ImageCarousel_wrapper__mOtAV"};